var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-filetypes",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "255px",
    height: "142px",
    viewBox: "0 0 255 142",
    enableBackground: "new 0 0 255 142",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-presentation",
    fill: "#603311",
    d: "M149.688,37.719V17.75l22.188,22.188h-19.969 C150.681,39.938,149.688,38.944,149.688,37.719z M171.875,51.031v68.781c0,2.451-1.986,4.438-4.438,4.438H92 c-2.451,0-4.438-1.986-4.438-4.438V22.188c0-2.451,1.987-4.438,4.438-4.438h46.594c1.226,0,2.219,0.993,2.219,2.219v24.406 c0,2.451,1.986,4.438,4.438,4.438h24.406C170.882,48.813,171.875,49.806,171.875,51.031z M136.375,106.5 c0-1.639-1.796-3.054-4.438-3.822v-9.49h-8.875v9.49c-2.642,0.769-4.438,2.184-4.438,3.822c0,2.451,3.974,4.438,8.875,4.438 S136.375,108.951,136.375,106.5z M149.156,81.658l-3.55-17.75c-0.208-1.037-1.118-1.783-2.175-1.783h-31.863 c-1.058,0-1.968,0.746-2.176,1.783l-3.55,17.75c-0.24,1.201,0.539,2.371,1.74,2.611c0.144,0.028,0.289,0.043,0.436,0.043h38.961 c1.227,0,2.219-0.993,2.219-2.219C149.199,81.947,149.186,81.802,149.156,81.658z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.2b410afc1ab8c5a438d7385d4111f9ed.svg";
export { ForwardRef as ReactComponent };